var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13647 30.6818H38.8637V40.909H6.13647V30.6818Z",
    fill: "#1A565F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5454 4.73318V0H20.4545V4.73318C16.6366 5.23041 13.1301 7.09996 10.5895 9.99288C8.04884 12.8858 6.64775 16.6044 6.64771 20.4545V24.0341H38.3522V20.4545C38.3518 16.6045 36.9505 12.8862 34.41 9.99333C31.8694 7.1005 28.3632 5.23083 24.5454 4.73318Z",
    fill: "#1A565F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.6819V25.5682L22.5 14.3182L45 25.5682V30.6819H42.4432V40.9091H45V45.0001H0V40.9091H2.55682V30.6819H0ZM7.67045 30.6819V40.9091H11.25V30.6819H7.67045ZM33.75 30.6819H37.3295V40.9091H33.75V30.6819ZM16.3636 30.6819V40.9091H19.9432V30.6819H16.3636ZM25.0568 30.6819V40.9091H28.6364V30.6819H25.0568Z",
    fill: "#78E183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.58dc421f7b591ff79fe4b20a7021de44.svg";
export { ForwardRef as ReactComponent };